<!-- eslint-disable vue/no-deprecated-dollar-listeners-api -->
<template>
  <SModal
    v-bind="$attrs"
    v-model="displayModal"
    scrollable
    :show-footer-gradient="false"
    :header-title="$t('calendar.event_details.title')"
    :header-sub-title="category ? $t('calendar.event_details.category', { category }) : undefined"
    v-on="$listeners"
  >
    <event-details
      v-if="displayModal"
      :event="event"
      :event-id="eventId"
      :notification="notification"
      @category-changed="(val) => (category = val)"
      @close="$emit('close')"
    />
  </SModal>
</template>

<script>
import EventDetails from 'src/components/calendar/event/details/EventDetails.vue'

export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'EventDetailsModal',
  components: {
    EventDetails,
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },

    event: {
      type: Object,
      default: null,
    },

    eventId: {
      type: [String, Number],
      default: null,
    },

    notification: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    displayModal: false,
    category: null,
  }),

  emits: ['close'],

  watch: {
    modelValue: {
      handler: function (newVal) {
        this.displayModal = newVal
      },

      immediate: true,
    },
  },
}
</script>
